import React from 'react';
import { FactoryIcon, ClockIcon, ZapIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
interface AvailabilityDeliveryProps {
  onRequestQuote: () => void;
}
export function AvailabilityDelivery({
  onRequestQuote
}: AvailabilityDeliveryProps) {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  return <section className="py-20 bg-dark-bg border-y border-dark-border" data-id="element-143" data-mp="3rn9g9b4hikfh">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144" data-mp="8lh3c7kjocz">
        <div className="text-center mb-10" data-id="element-145" data-mp="a6cf41pjbbw">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-146" data-mp="3hpv8dzwmn3ys">
            {en ? <>
                Availability and{' '}
                <span className="text-brand-yellow" data-id="element-147" data-mp="3mopsr6a8t0l0">delivery</span>
              </> : ru ? <>
                Наличие и <span className="text-brand-yellow" data-id="element-148" data-mp="3cq0gpu512aco">доставка</span>
              </> : <>
                Dostupnost i <span className="text-brand-yellow" data-id="element-149" data-mp="3ghork0ipfx37">isporuka</span>
              </>}
          </h2>
        </div>

        <div className="bg-dark-surface border border-dark-border rounded-industrial p-6 md:p-8 mb-8" data-id="element-150" data-mp="3bjdl7zrmc4pq">
          <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-151" data-mp="3qg4ju6tgxcea">
            {en ? <>
                Due to high demand, stock quantities are{' '}
                <span className="text-white font-semibold" data-id="element-152" data-mp="2xsqlq5e1aasl">
                  limited and subject to daily changes
                </span>
                . For sold-out models, the standard lead time for import and
                delivery directly from production (with a guaranteed maximum
                capacity of a new battery) is{' '}
                <span className="text-brand-yellow font-bold" data-id="element-153" data-mp="2f1r1fhhhhp5n">4–8 weeks</span>.
              </> : ru ? <>
                Из-за высокого спроса количество на складе{' '}
                <span className="text-white font-semibold" data-id="element-154" data-mp="2zqrx8uf2npeu">
                  ограничено и может меняться ежедневно
                </span>
                . Для распроданных моделей стандартный срок импорта и поставки
                напрямую с производства (с гарантированной максимальной ёмкостью
                новой батареи) составляет{' '}
                <span className="text-brand-yellow font-bold" data-id="element-155" data-mp="3dgvf796x4wyh">4–8 недель</span>.
              </> : <>
                Zbog visoke potražnje, količine na stanju su{' '}
                <span className="text-white font-semibold" data-id="element-156" data-mp="2kuan26imcgtv">
                  ograničene i podložne promenama na dnevnom nivou
                </span>
                . Za modele koji se rasprodaju, standardni rok za uvoz i
                isporuku direktno iz proizvodnje (uz garantovan maksimalni
                kapacitet nove baterije) iznosi{' '}
                <span className="text-brand-yellow font-bold" data-id="element-157" data-mp="a1hj25vadt8w">4–8 nedelja</span>
                .
              </>}
          </p>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed mt-4" data-id="element-158" data-mp="1uih0s5at6nmn">
            {en ? <>
                Contact us for{' '}
                <span className="text-white font-semibold" data-id="element-159" data-mp="1ktpby611ojfy">
                  current availability and reservations
                </span>
                .
              </> : ru ? <>
                Свяжитесь с нами для уточнения{' '}
                <span className="text-white font-semibold" data-id="element-160" data-mp="1buc3ngonq0wt">
                  актуального наличия и бронирования
                </span>
                .
              </> : <>
                Kontaktirajte nas za{' '}
                <span className="text-white font-semibold" data-id="element-161" data-mp="ww9v0s2rqp8p">
                  trenutno stanje i rezervaciju
                </span>
                .
              </>}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-162" data-mp="2r9j96x69eyxa">
          <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/60 rounded-industrial p-4" data-id="element-163" data-mp="2zah52vaysq2s">
            <FactoryIcon className="w-6 h-6 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-164" data-mp="34a3ib4qsm6bl" />
            <div data-id="element-165" data-mp="2pcjhma0xixb8">
              <p className="text-white font-semibold text-sm mb-1" data-id="element-166" data-mp="2pd2psz0s27c2">
                {en ? 'Direct from production' : ru ? 'Напрямую с производства' : 'Direktno iz proizvodnje'}
              </p>
              <p className="text-gray-400 text-xs" data-id="element-167" data-mp="2laplmf1oihhe">
                {en ? 'Maximum battery capacity, full motor power.' : ru ? 'Максимальная ёмкость аккумулятора, полная мощность мотора.' : 'Maksimalni kapacitet baterije, puna snaga motora.'}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/60 rounded-industrial p-4" data-id="element-168" data-mp="1xlwv4y3tt1u6">
            <ClockIcon className="w-6 h-6 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-169" data-mp="21ojkmsd0yao7" />
            <div data-id="element-170" data-mp="1j0is0b0owu4v">
              <p className="text-white font-semibold text-sm mb-1" data-id="element-171" data-mp="1dzbjuaumxsxo">
                {en ? '4–8 weeks lead time' : ru ? 'Срок поставки 4–8 недель' : '4–8 nedelja isporuka'}
              </p>
              <p className="text-gray-400 text-xs" data-id="element-172" data-mp="1myotb3irehie">
                {en ? 'For models not currently in stock.' : ru ? 'Для моделей, которых нет в наличии.' : 'Za modele koji nisu na stanju.'}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/60 rounded-industrial p-4" data-id="element-173" data-mp="2arf3p8b0ksqk">
            <ZapIcon className="w-6 h-6 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-174" data-mp="2knif74rra3q6" />
            <div data-id="element-175" data-mp="2klfenqsz8s77">
              <p className="text-white font-semibold text-sm mb-1" data-id="element-176" data-mp="2foxfr7kbvo2s">
                {en ? 'Quick response' : ru ? 'Быстрый ответ' : 'Brz odgovor'}
              </p>
              <p className="text-gray-400 text-xs" data-id="element-177" data-mp="1d96c7hon5x15">
                {en ? 'We reply to all inquiries within 24h.' : ru ? 'Отвечаем на все запросы в течение 24 ч.' : 'Odgovaramo na sve upite u roku od 24h.'}
              </p>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-178" data-mp="1w2jyyzi7ax5o">
          <Button variant="primary" size="lg" onClick={onRequestQuote} data-id="element-179" data-mp="1w1h98uwm70rc">
            {en ? 'Check availability' : ru ? 'Проверить наличие' : 'Proverite dostupnost'}
          </Button>
        </div>
      </div>
    </section>;
}